module.exports = __webpack_public_path__ + "img/clinique.e5160528.jpg";